import Modal from "../../layouts/Modal";
import { ICollectionOption } from "../../models/CollectionOption";
import AddEditCollectionOption from "./AddEditCollectionOption";

interface CollectionOptionModalProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  collectionOption?: ICollectionOption;
}

export default function CollectionOptionModal({ open, setOpen, collectionOption }: CollectionOptionModalProps) {
  return (
    <Modal width="max-w-2xl" open={open} setOpen={setOpen}>
      <AddEditCollectionOption collectionOption={collectionOption} setOpen={setOpen} />
    </Modal>
  );
}
